'use strict';

const schaffrathDetail = require('schaffrath/product/detail');

schaffrathDetail.copyProductLink = function () {
    $('body').on('click', '#fa-link', function (e) {
        e.preventDefault();

        const $temp = $('<input>');
        $('body').append($temp);
        $temp.val($('#shareUrl').val()).select();
        document.execCommand('copy');
        $temp.remove();

        $('.copy-link-message').attr('role', 'alert');
        $('.copy-link-message').removeClass('d-none');
        window.setTimeout(function () {
            $('.copy-link-message').addClass('d-none');
        }, 3000);
    });
};

module.exports = schaffrathDetail;
